<script>
  import GraficoProvince from './GraficoProvince.svelte';
  import { getContext } from 'svelte';
  import { fly } from 'svelte/transition';
  import Switch from './util/Switch.svelte';
  import Grafico from './grafico/Grafico.svelte';
  import CardList from './card/CardList.svelte';
	import Torta from './grafico/Torta.svelte';
  import { dataRegioni } from './stores/data-regioni.store.js';
  import { scaleLinear } from 'd3-scale';
  import tippy from 'sveltejs-tippy';
  import { regioneSelezionata, dataProvince } from './stores/data-province.store.js';

  export let source = {
    url:
      'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-regioni/dpc-covid19-ita-regioni.csv',
    desc: 'pcm-dpc',
  };
  export let regione = 'Toscana';
	let labelTorta = "Nuovi positivi per provincia";
  const { open } = getContext('simple-modal');

  let dettaglio = false;
  let puntuale = false;

	let updateDate = new Date();
	let updateDateBefore = new Date();

  $: if ($dataProvince.length > 0) {
		updateDate = new Date($dataProvince[$dataProvince.length - 1].data)
	}

	$: if (updateDate != null) {
		updateDateBefore = new Date(updateDate);
		updateDateBefore.setDate(updateDate.getDate() - 1);
	}  	


  $: pointsTortaToday = $dataProvince
     .filter((entry) => entry.denominazione_regione === regione)
     .filter((entry) => datesAreOnSameDay(new Date(entry.data), updateDate))
     .map(entry => { 
			return {
			label : entry.denominazione_provincia,
			value : entry.totale_casi
		};
	});

	$: pointsTortaYesterday = $dataProvince
     .filter((entry) => entry.denominazione_regione === regione)
     .filter((entry) => datesAreOnSameDay(new Date(entry.data), updateDateBefore))
     .map(entry => { 
			return {
			label : entry.denominazione_provincia,
			value : entry.totale_casi
		};
	});

	$: pointsTorta = pointsTortaToday.map((entry, i) => {
		return {
			label: entry.label,
			value: Math.max(0, pointsTortaToday[i].value - pointsTortaYesterday[i].value)
		}
	})

  $: points = $dataRegioni
    .filter((entry) => entry.denominazione_regione === regione)
    .map((entry, i) => {
      return {
        x: new Date(entry.data).getTime(),
        y: [
          { key: 'casi', value: entry.totale_casi, color: 'white' },
          { key: 'guariti', value: entry.dimessi_guariti, color: 'SeaGreen' },
          { key: 'deceduti', value: entry.deceduti, color: 'DarkGray' },
          {
            key: 'terapia intensiva',
            value: entry.terapia_intensiva,
            color: 'DarkRed',
          },
          {
            key: 'ospedalizzati',
            value: entry.totale_ospedalizzati,
            color: 'red',
          },
					{
						key: 'isolamento',
						value: entry.isolamento_domiciliare,
						color: 'orange',
					}
        ],
      };
    });

  $: points2 = $dataRegioni
    .filter((entry) => entry.denominazione_regione === regione)
    .map((entry, i, array) => {
      return {
        x: new Date(entry.data).getTime(),
        y: [
          {
            key: 'casi',
            value: i > 0 ? array[i].totale_casi - array[i - 1].totale_casi : 0,
            color: 'white',
          },
          {
            key: 'guariti',
            value:
              i > 0
                ? array[i].dimessi_guariti - array[i - 1].dimessi_guariti
                : 0,
            color: 'SeaGreen',
          },
          {
            key: 'deceduti',
            value: i > 0 ? array[i].deceduti - array[i - 1].deceduti : 0,
            color: 'DarkGray',
          },
          {
            key: 'terapia intensiva',
            value:
              i > 0
                ? Math.max(
                    0,
                    array[i].terapia_intensiva - array[i - 1].terapia_intensiva
                  )
                : 0,
            color: 'DarkRed',
          },
          {
            key: 'ospedalizzati',
            value:
              i > 0
                ? Math.max(
                    0,
                    array[i].totale_ospedalizzati -
                      array[i - 1].totale_ospedalizzati
                  )
                : 0,
            color: 'red',
          },
        {
          key: 'isolamento',
          value: 
            i > 0
              ? Math.max(
                  0,
                  array[i].isolamento_domiciliare -
                    array[i - 1].isolamento_domiciliare
                )
              : 0,
          color: 'orange',
        }
        ],
      };
    });



  $: points3 = $dataRegioni
	    .filter((entry) => entry.denominazione_regione === regione)
    	.map((entry, i, array) => {
				return {
					x: new Date(entry.data).getTime(),
					y: [
						{
							key: 'tamponi',
							value: i > 0
									? Math.max(
											0,
											array[i].tamponi - array[i - 1].tamponi
										)
									: 0,
							color: 'yellow',
						}
					],
				};
			});

  $: cardValue =
    points2.length > 0 ? calcolaCard(points2, points3) : [];


    function calcolaCard(points2, points3) {
	  const arry1Today = calcola(points2.flatMap((entry) => entry.y));
    const arry2Today = calcolaTamponi(points3.flatMap((entry) => entry.y));
    const arry1Yesterday = calcola(points2.flatMap((entry) => entry.y), 2);
    const arry2Yesterday = calcolaTamponi(points3.flatMap((entry) => entry.y), 2);
    const arry12Today = arry2Today.concat(arry1Today);
    const arry12Yesterday = arry2Yesterday.concat(arry1Yesterday);
    const perc = arry12Today[1].value/arry12Today[0].value * 100;
    const percYesterday = arry12Yesterday[1].value/arry12Yesterday[0].value * 100;

    arry12Today.push({
        label: "Rapporto casi/tamponi",
        value: perc.toFixed(2) + "%",
        percentage: (((perc - percYesterday)/percYesterday) * 100).toFixed(0),
        direction: perc - percYesterday,
        invert: false,
      });

 
      const percCard = arry12Today[7];
    arry12Today[7] = arry12Today[2];
    arry12Today[2] = percCard;
    arry12Today[0].invert = true;
    arry12Today[3].invert = false;
    arry12Today[6].invert = false;
    arry12Today[7].invert = true;

    return arry12Today;
	}

  function calcola(arr, days = 1) {
    let ieri = arr.slice(arr.length - (12 * days), arr.length - (6 * days));
    let oggi = arr.slice(arr.length - 6 * days, arr.length - (6 * days)  + 6);
    let result = [];
    for (let i = 0; i < 6; i++) {
      result.push({
        label: oggi[i].key,
        value: oggi[i].value,
        percentage: Math.round(
          ((oggi[i].value - ieri[i].value) / ieri[i].value) * 100
        ),
        direction: oggi[i].value - ieri[i].value,
        invert: i == 2 ? true : false,
      });
    }
    return result;
  }

	function calcolaTamponi(arr, days = 1) {
    let ieri = arr.slice(arr.length - (2 * days), arr.length - (1 * days));
    let oggi = arr.slice(arr.length - (1 * days), arr.length -  (days)  + 1);


    let result = [];
    for (let i = 0; i < 1; i++) {
      result.push({
        label: oggi[i].key,
        value: oggi[i].value,
        percentage: Math.round(
          ((oggi[i].value - ieri[i].value) / ieri[i].value) * 100
        ),
        direction: oggi[i].value - ieri[i].value,
        invert: true,
      });
    }
    return result;
  }
  
  const showPopup = (regione) => {
    regioneSelezionata.update((value) => (value = regione));
    open(GraficoProvince, { message: 'Grafico province' });
  };

  const showPopupCard = () => {
    open(CardList, { cardArrayValue: cardValue });
  };

	const datesAreOnSameDay = (first, second) => {
		return first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();
	}

	$: dataAggiornamento = points.length > 0 ? "Dati del giorno " + dtf.format(new Date(points[points.length - 1].x)) : "Recupero dati in corso ...";
	
  const dtf = new Intl.DateTimeFormat('it', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit'
  });
</script>

<div class="bg-gray-200 rounded-lg p-6 pb-20">
  <div class="flex flex-wrap items-center mb-4 bg-blue-500 p-2 rounded-lg ">
    <div class="w-2/5 h-12 text-white font-bold text-lg">
			<slot></slot>
    </div>
    <div class="w-1/5 h-12">
      <!-- <Switch bind:checked={puntuale} label={''} title="Puntuali" /> -->
    </div>
    
    <div class="w-1/5 h-12">

      <!-- <button
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 rounded flex mr-2 mb-2"
        title="Dati del giorno"
        on:click|preventDefault={() => showPopupCard()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="32"
            height="32">
            <path  fill="#fafafa" stroke-width="20"
              d="M6.176,7.241V6.78c0-0.221-0.181-0.402-0.402-0.402c-0.221,0-0.403,0.181-0.403,0.402v0.461C4.79,7.416,4.365,7.955,4.365,8.591c0,0.636,0.424,1.175,1.006,1.35v3.278c0,0.222,0.182,0.402,0.403,0.402c0.222,0,0.402-0.181,0.402-0.402V9.941c0.582-0.175,1.006-0.714,1.006-1.35C7.183,7.955,6.758,7.416,6.176,7.241
              M5.774,9.195c-0.332,0-0.604-0.272-0.604-0.604c0-0.332,0.272-0.604,0.604-0.604c0.332,0,0.604,0.272,0.604,0.604C6.377,8.923,6.105,9.195,5.774,9.195
              M10.402,10.058V6.78c0-0.221-0.181-0.402-0.402-0.402c-0.222,0-0.402,0.181-0.402,0.402v3.278c-0.582,0.175-1.006,0.714-1.006,1.35c0,0.637,0.424,1.175,1.006,1.351v0.461c0,0.222,0.181,0.402,0.402,0.402c0.221,0,0.402-0.181,0.402-0.402v-0.461c0.582-0.176,1.006-0.714,1.006-1.351C11.408,10.772,10.984,10.233,10.402,10.058M10,12.013c-0.333,0-0.604-0.272-0.604-0.604S9.667,10.805,10,10.805c0.332,0,0.604,0.271,0.604,0.604S10.332,12.013,10,12.013M14.629,8.448V6.78c0-0.221-0.182-0.402-0.403-0.402c-0.221,0-0.402,0.181-0.402,0.402v1.668c-0.581,0.175-1.006,0.714-1.006,1.35c0,0.636,0.425,1.176,1.006,1.351v2.07c0,0.222,0.182,0.402,0.402,0.402c0.222,0,0.403-0.181,0.403-0.402v-2.07c0.581-0.175,1.006-0.715,1.006-1.351C15.635,9.163,15.21,8.624,14.629,8.448
              M14.226,10.402c-0.331,0-0.604-0.272-0.604-0.604c0-0.332,0.272-0.604,0.604-0.604c0.332,0,0.604,0.272,0.604,0.604C14.83,10.13,14.558,10.402,14.226,10.402
              M17.647,3.962H2.353c-0.221,0-0.402,0.181-0.402,0.402v11.27c0,0.222,0.181,0.402,0.402,0.402h15.295c0.222,0,0.402-0.181,0.402-0.402V4.365C18.05,4.144,17.869,3.962,17.647,3.962
              M17.245,15.232H2.755V4.768h14.49V15.232z" />
          </svg>
        <span />
      </button> -->
      <!-- <Switch bind:checked={dettaglio} label={'province'} /> -->
    </div>
		<div class="w-1/5 h-12">
       <button
        class="bg-blue-700 hover:bg-blue-800 text-white font-bold p-2 rounded flex ml-2 mu-2"
        on:click|preventDefault={() => showPopup(regione)} title="Grafico Province"> 
				<svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="32"
          height="32"
					preserveAspectRatio="xMaxYMax meet">
            <path  fill="#fafafa" stroke-width="20" transform="translate(6, 6)"
            d="M17.431,2.156h-3.715c-0.228,0-0.413,0.186-0.413,0.413v6.973h-2.89V6.687c0-0.229-0.186-0.413-0.413-0.413H6.285c-0.228,0-0.413,0.184-0.413,0.413v6.388H2.569c-0.227,0-0.413,0.187-0.413,0.413v3.942c0,0.228,0.186,0.413,0.413,0.413h14.862c0.228,0,0.413-0.186,0.413-0.413V2.569C17.844,2.342,17.658,2.156,17.431,2.156
            M5.872,17.019h-2.89v-3.117h2.89V17.019zM9.587,17.019h-2.89V7.1h2.89V17.019z
            M13.303,17.019h-2.89v-6.651h2.89V17.019z
            M17.019,17.019h-2.891V2.982h2.891V17.019z" />
        </svg>
      </button>
    </div>
  </div>
	<h2 class="text-blue-600 font-bold text-lg">{dataAggiornamento}</h2>
	<CardList bind:cardArrayValue={cardValue} class="mb-8"/>
	<br/><br/><br/><br/><br/><br/>
	<Torta bind:points={pointsTorta} bind:label={labelTorta} class="mt-8 mb-8"></Torta>
	<br/>
	<h2 class="text-blue-600 font-bold text-lg">Totale</h2>
  <Grafico bind:points bind:source class="mb-8"/>
	<br/>
  <h2 class="text-blue-600 font-bold text-lg">Puntuale</h2>
  <Grafico bind:points={points2} bind:source class="mb-8"/>
	<br/>
	<h2 class="text-blue-600 font-bold text-lg">Tamponi</h2>
  <Grafico bind:points={points3} bind:source />
  <!-- {#if !puntuale}
    <Grafico bind:points {source} />
  {:else}
    <Grafico bind:points={points2} {source} />
  {/if} -->
</div>
